module.exports = __webpack_public_path__ + "static/img/dots.6579cd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/textures/dots.png
// module id = 441
// module chunks = 1